import { observable } from "mobx";
import { inject, observer, Provider } from "mobx-react";
import React = require("react");
import { RouteComponentProps } from "react-router-dom";
import { DepartmentStore } from "./core/stores/DepartmentStore";
import { Departments } from "./components/Departments";
import { RootStore } from "../../../core/stores/RootStore";

interface MatchParams {
  id: string;
}

interface IProps extends RouteComponentProps<MatchParams> {
  RootStore?: RootStore;
}

interface Stores {
  DepartmentStore: DepartmentStore;
}

@inject("RootStore")
@observer
export class DepartmentPage extends React.Component<IProps> {
  private stores: Stores;

  constructor(props: IProps) {
    super(props);
    console.log("this.props.match.params.id", this.props.match.params);

    this.stores = {
      DepartmentStore: new DepartmentStore(props.RootStore),
    };
  }

  async componentDidMount() {
    this.stores.DepartmentStore.Init();
  }

  public render() {
    return (
      <Provider {...this.stores}>
        <Departments />
      </Provider>
    );
  }
}
